import { upamDtoToModelSchemas } from '@/app/platform/platform-data/mapper/upam-dto-to-model.schemas';

export const coreDataSchemas = [...upamDtoToModelSchemas];
